import { render } from "./ResourcesMobileGroup2.vue?vue&type=template&id=ee3144fc&scoped=true"
import script from "./ResourcesMobileGroup2.vue?vue&type=script&lang=js"
export * from "./ResourcesMobileGroup2.vue?vue&type=script&lang=js"

import "./ResourcesMobileGroup2.vue?vue&type=style&index=0&id=ee3144fc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3144fc"]])

export default __exports__